<script setup>
import CategoryCard from "~/components/cards/CategoryCard.vue"
import ProductCard from "~/components/cards/ProductCard.vue"

const dairamon = useDairamon()
const route = useRoute()

const category = await dairamon.categories.getByURL(route.params.url)
const url = route.params.url ? route.params.url.join("/") + "/" : ""

const { data: products } = await dairamon.products.list({ category_id: [...category.ids], sort: 'score' });
</script>

<template>
  <!-- CATEGORY SLIDER -->
  <section v-if="category?.children" class="categories">
    <Slider :data="category.children">
      <template #card="data"><CategoryCard :data="data" parent="slider" :url="route.params.url.join('/') + '/'"></CategoryCard></template>
    </Slider>
  </section>

  <!-- PRODUCT LIST -->
  <section class="products page">
    <template v-for="(item, index) in products.data">
      <ProductCard v-if="index !== 5" class="product" :data="item"></ProductCard>
    </template>
  </section>
</template>

<style scoped lang="scss">
.categories {
  margin-bottom: 5rem;
}

.products {
  // width: 100%;
  margin: auto;
  // padding: 0;

  display: grid;
  //grid-template-columns: repeat(var(--product-listing-grid), minmax(0, 1fr));
  grid-template-columns: repeat(auto-fill, minmax(var(--product-card-width), 1fr));
  // grid-template-columns: repeat(auto-fill, minmax(min(var(--product-card-width), 100%), 1fr));

  gap: var(--product-card-gap);
  align-items: stretch;
}

.banner {
  width: auto;
  grid-column: 2 span;
  background-color: var(--color2);
  display: grid;
  align-content: center;
  justify-content: center;

  p {
    font-size: 3rem;
  }
}
</style>
